module.exports = __webpack_public_path__ + "img/under-maintenance.1c11b807.svg";